import React from 'react';
import { Instagram, Twitter, Linkedin } from 'lucide-react';
import { mockData } from '../mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialIcons = {
    Instagram: Instagram,
    Twitter: Twitter,
    Linkedin: Linkedin
  };

  return (
    <footer style={{ 
      background: 'var(--bg-secondary)', 
      borderTop: '1px solid var(--border-light)',
      padding: '80px 0 40px 0'
    }}>
      <div className="container">
        <div style={{ marginBottom: '60px' }}>
          {/* Sitemap Section */}
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2 className="heading-1" style={{ marginBottom: '32px' }}>Site Navigation</h2>
            <p className="body-regular" style={{ 
              color: 'var(--text-secondary)', 
              maxWidth: '600px', 
              margin: '0 auto 40px auto' 
            }}>
              High-end luxury hospitality experiences from large to small events, weddings, travel groups, retreats, and elite celebrations reaching unparalleled sophistication
            </p>
          </div>

          {/* Main Pages */}
          <div style={{ marginBottom: '50px' }}>
            <h3 className="heading-2" style={{ 
              textAlign: 'center', 
              marginBottom: '30px',
              color: 'var(--color-fence-green)'
            }}>
              Main Pages
            </h3>
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
              gap: '20px' 
            }}>
              {mockData.siteMap.mainPages.map((page, index) => (
                <div key={index} style={{
                  padding: '20px',
                  border: '1px solid var(--border-light)',
                  borderRadius: '0px',
                  background: 'var(--bg-primary)',
                  textAlign: 'center'
                }}
                className="hover-lift">
                  <a href={page.path} style={{ textDecoration: 'none' }}>
                    <h4 className="heading-3" style={{ 
                      marginBottom: '8px',
                      color: 'var(--color-gold)'
                    }}>
                      {page.title}
                    </h4>
                    <p className="body-small" style={{ 
                      color: 'var(--text-secondary)',
                      margin: 0
                    }}>
                      {page.description}
                    </p>
                  </a>
                </div>
              ))}
            </div>
          </div>

          {/* Key Features */}
          <div style={{ marginBottom: '50px' }}>
            <h3 className="heading-2" style={{ 
              textAlign: 'center', 
              marginBottom: '30px',
              color: 'var(--color-fence-green)'
            }}>
              Key Features & Services
            </h3>
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
              gap: '20px' 
            }}>
              {mockData.siteMap.keyFeatures.map((feature, index) => (
                <div key={index} style={{
                  padding: '20px',
                  border: '1px solid var(--border-light)',
                  borderRadius: '0px',
                  background: 'var(--color-lavender)',
                  textAlign: 'center'
                }}
                className="hover-lift">
                  <a href={feature.anchor || '#'} style={{ textDecoration: 'none' }}>
                    <h4 className="heading-3" style={{ 
                      marginBottom: '8px',
                      color: 'var(--color-fence-green)'
                    }}>
                      {feature.title}
                    </h4>
                    <p className="body-small" style={{ 
                      color: 'var(--text-secondary)',
                      margin: 0
                    }}>
                      {feature.description}
                    </p>
                  </a>
                </div>
              ))}
            </div>
          </div>

          {/* Special Sections */}
          <div style={{ marginBottom: '50px' }}>
            <h3 className="heading-2" style={{ 
              textAlign: 'center', 
              marginBottom: '30px',
              color: 'var(--color-fence-green)'
            }}>
              Specialized Information
            </h3>
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
              gap: '20px' 
            }}>
              {mockData.siteMap.specialSections.map((section, index) => (
                <div key={index} style={{
                  padding: '20px',
                  border: '1px solid var(--color-gold)',
                  borderRadius: '0px',
                  background: 'var(--bg-primary)',
                  textAlign: 'center'
                }}
                className="hover-lift">
                  <h4 className="heading-3" style={{ 
                    marginBottom: '8px',
                    color: 'var(--color-gold)'
                  }}>
                    {section.title}
                  </h4>
                  <p className="body-small" style={{ 
                    color: 'var(--text-secondary)',
                    margin: 0
                  }}>
                    {section.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Original Footer Content */}
        <div className="grid-two-column" style={{ marginBottom: '48px' }}>
          <div>
            <h3 className="heading-2" style={{ marginBottom: '24px' }}>Decadent Palete</h3>
            <p className="body-regular" style={{ marginBottom: '32px', color: 'var(--text-secondary)' }}>
              We provide high-end luxury hospitality experiences from large to small events, weddings, travel groups, retreats, and elite celebrations reaching unparalleled sophistication. We don't just cook — we provide unforgettable moments and services.
            </p>
            
            {/* Business & Community */}
            <div>
              <h3 className="heading-3 mb-6">Business & Community</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <a href="/investors" className="btn-secondary">Investors</a>
                <a href="/contributors" className="btn-secondary">Contributors</a>
                <a href="/charity" className="btn-secondary">Charity & Community</a>
                <a href="/testimony" className="btn-secondary">Testimonials</a>
                <a href="/careers" className="btn-secondary">Careers</a>
                <a href="/admin" className="btn-secondary">Admin Dashboard</a>
              </div>
            </div>

            {/* Legal Links */}
            <div>
              <h3 className="heading-3 mb-6">Legal & Policies</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <a href="/member-policy" className="btn-secondary">Member Policy</a>
                <a href="/privacy-policy" className="btn-secondary">Privacy Policy</a>
                <a href="/terms-conditions" className="btn-secondary">Terms & Conditions</a>
              </div>
            </div>

            {/* Contact Info */}
            <div style={{ marginBottom: '32px' }}>
              <p className="body-regular" style={{ marginBottom: '8px', color: 'var(--text-primary)' }}>
                <strong>Contact Us:</strong>
              </p>
              <p className="body-regular" style={{ marginBottom: '4px', color: 'var(--text-secondary)' }}>
                Phone: <a href="tel:9736663705" style={{ color: 'var(--color-gold)', textDecoration: 'none' }}>(973) 666-3705</a>
              </p>
              <p className="body-regular" style={{ marginBottom: '16px', color: 'var(--text-secondary)' }}>
                Email: <a href="mailto:info@decadentpalete.com" style={{ color: 'var(--color-gold)', textDecoration: 'none' }}>info@decadentpalete.com</a>
              </p>
              <p className="body-regular" style={{ marginBottom: '16px', color: 'var(--text-secondary)' }}>
                Visit: <a href="https://decadentpalete.com" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--color-gold)', textDecoration: 'none' }}>decadentpalete.com</a>
              </p>
            </div>
            
            <div style={{ display: 'flex', gap: '16px' }}>
              {mockData.socialMedia.map((social) => {
                const IconComponent = socialIcons[social.icon];
                return (
                  <a
                    key={social.platform}
                    href={social.url}
                    style={{
                      padding: '12px',
                      border: '1px solid var(--border-light)',
                      borderRadius: '0px',
                      color: 'var(--text-primary)',
                      textDecoration: 'none',
                      transition: 'all 0.2s ease'
                    }}
                    className="hover-lift"
                    onMouseEnter={(e) => {
                      e.target.style.borderColor = 'var(--color-gold)';
                      e.target.style.color = 'var(--color-gold)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.borderColor = 'var(--border-light)';
                      e.target.style.color = 'var(--text-primary)';
                    }}
                  >
                    <IconComponent size={20} />
                  </a>
                );
              })}
            </div>
          </div>
          
          <div>
            <h4 className="heading-3" style={{ marginBottom: '24px' }}>Quick Links</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <a href="/" className="btn-secondary">Home</a>
              <a href="/services" className="btn-secondary">Our Services</a>
              <a href="/blog" className="btn-secondary">Blog</a>
              <a href="/custom-cakes" className="btn-secondary">Custom Cakes</a>
              <a href="/inquiry" className="btn-secondary">Make an Inquiry</a>
              <a href="/about" className="btn-secondary">About Our Chef</a>
              <a 
                href="#gift-cards" 
                className="btn-secondary"
                style={{ color: 'var(--color-gold)', fontWeight: '600' }}
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = '/about#gift-cards';
                }}
              >
                DP Gift Cards
              </a>
            </div>
            
            {/* Customer Support Section */}
            <div style={{ marginTop: '32px' }}>
              <h4 className="heading-3" style={{ marginBottom: '16px', color: 'var(--color-fence-green)' }}>Customer Support</h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <a href="/faqs" className="btn-secondary">FAQs</a>
                <a href="/feedback" className="btn-secondary">Share Feedback</a>
              </div>
            </div>
          </div>
        </div>
        
        <div style={{
          borderTop: '1px solid var(--border-light)',
          paddingTop: '32px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '16px'
        }}>
          <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
            © {currentYear} Decadent Palete. All rights reserved. | Providing unforgettable moments and services.
          </p>
          <p className="body-small">
            <a href="https://decadentpalete.com" target="_blank" rel="noopener noreferrer" 
               style={{ color: 'var(--color-gold)', textDecoration: 'none', fontWeight: '600' }}>
              decadentpalete.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};